import {useAuth} from './../../../context/authContext/index';
import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {sendConfirmation} from '../../../services/auth';
import {googleAnalyticsInstance} from '../../../utilities/helper/googleAnalitics';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const UseSendConfirmation = () => {
  const event: IGoogleEvent = {
    category: 'my-ads-page-checked',
    action: 'کاربر وارد صفحه آگهی های من شد',
  };
  const navigate = useNavigate();
  const {login} = useAuth();
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: ISendConfirmationCodePayload) => {
      return sendConfirmation(payload);
    },
    onSuccess: (data, variables) => {
      if (!data?.is_registered) {
        navigate('/auth/signUp', {
          state: {
            mobile: variables?.mobile,
            code: variables?.otp_code,
          },
        });
        return;
      } else {
        login({
          is_registered: data?.is_registered,
          message: data?.message,
          token: data?.token,
          profile: {
            farmer_profile: data?.farmer_profile,
            supplier_profile: data?.supplier_profile,
            marrket_profile: data?.market_profile,
          },
        });
        googleAnalyticsInstance.eventGoogleAnalytics(event);
      }
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate};
};

export default UseSendConfirmation;
